module.exports = __webpack_public_path__ + "img/ruihong_swiper_03.dddbd63c.jpg";